import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const posterApi = {
  getPosters: (params) => {
    return axiosInstance.get(`${adminBaseUrl}/posters`, {
      params: {
        page: params.page,
        pageSize: params.pageSize
      }
    })
  },

  getPosterDetail: (posterId) => {
    return axiosInstance.get(`${adminBaseUrl}/poster/${posterId}`);
  },

  updatePoster: (posterId, formData) => {
    return axiosInstance.put(
      `${adminBaseUrl}/poster/${posterId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  },

  createPoster(formData) {
    return axiosInstance.post(`${adminBaseUrl}/poster`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  deletePoster: (posterId) => {
    return axiosInstance.delete(`${adminBaseUrl}/poster/${posterId}`)
  }
}